import React from 'react';

const SectionHeader = ({ title, subtitle, icon: Icon, gradient, badges = [] }) => {
  const gradientClass = gradient 
    ? `bg-gradient-to-r ${gradient[0]} ${gradient[1]}`
    : 'bg-gradient-to-r from-gray-600 to-gray-700';

  return (
    <div className={`${gradientClass} p-4 md:p-6 flex items-center justify-between text-white`}>
      <div className="flex items-center gap-3">
        <div className="bg-white/20 p-2 rounded-lg backdrop-blur-sm">
          {Icon && <Icon className="text-2xl" />}
        </div>
        <div>
          <h2 className="text-2xl md:text-3xl font-bold tracking-tight">{title}</h2>
          {subtitle && (
            <p className={`${gradient?.[1]?.includes('green') ? 'text-green-100' : gradient?.[1]?.includes('gray') ? 'text-gray-300' : 'text-blue-100'} text-xs font-medium mt-1`}>
              {subtitle}
            </p>
          )}
        </div>
      </div>
      {badges.length > 0 && (
        <div className="flex gap-2 text-xs font-bold uppercase">
          {badges
            .filter(badge => typeof badge === 'string')
            .map((badge, index) => (
              <span
                key={index}
                className={`px-2 py-1 rounded ${
                  badge === 'Mega' ? 'bg-orange-500/90' :
                  badge === '5-Star' ? 'bg-indigo-400/90' :
                  badge === 'Shadow' ? 'bg-purple-800/90' :
                  'bg-gray-500/90'
                }`}
              >
                {badge}
              </span>
            ))}
        </div>
      )}
    </div>
  );
};

export default SectionHeader;
